import { useQuery } from '@tanstack/react-query';
import { getContactDuplicatedSuggestions } from 'Services/ai';
import { trackError } from 'Utils/errorMonitoring';

export default function useContactDuplicatedSuggestionsCount() {
    const { data, isLoading } = useQuery({
        queryKey: ['suggestions', 'contact_duplicated_detected'],
        queryFn: getContactDuplicatedSuggestions,
        refetchOnWindowFocus: false,
        onError: (err) => trackError(err),
    });

    const count = data?.count ?? data?.items?.length ?? 0;

    return {
        count,
        isLoading,
    };
}
